"use client";

type BulletItemProps = {
  text: string;
  colorClassName?: string;
  className?: string;
  textClassName?: string;
};

export function BulletItem({
  text,
  colorClassName = "bg-primary-500",
  className = "",
  textClassName = "text-sm text-slate-700 dark:text-slate-100"
}: BulletItemProps): JSX.Element {
  return (
    <li className={`flex items-start gap-3 [text-align:start] ${className}`}>
      <span className={`mt-1.5 h-2.5 w-2.5 flex-shrink-0 rounded-full ${colorClassName}`} />
      <span className={textClassName}>{text}</span>
    </li>
  );
}
